<template>
  <div class="alarm-log">
    <Page pageName="诉求列表" :search-bar="searchBar" :table="table" :pagination="pagination" :actionWidth="60">
      <template slot="table-operate" slot-scope="{scope}">
        <el-button type="text" style="margin-right: 20px"  @click="handleView(scope)">查看</el-button>
        <el-button type="text" :disabled="scope.approvalStatus !== 0" style="margin-right: 20px"  @click="handleApproval(scope)">处理</el-button>
        <!-- <el-button type="text" :disabled="scope.approvalStatus !== 0" class="btn" @click="handleApproval(scope,'拒绝')">拒绝</el-button> -->
      </template>
    </Page>
    <Dialogs title="详细信息" :is-show-dialog="isShowPage" width="40%" @handleClick="handleClose">
      <div slot="content">
        <div class="item">
          <span class="label">姓名:</span>
          <span class="value">{{ detail.appealName }}</span>
        </div>
        <div class="item">
          <span class="label">电话:</span>
          <span class="value">{{ detail.appealPhone }}</span>
        </div>
        <div class="item">
          <span class="label">申请时间:</span>
          <span class="value">{{ detail.appealDate }}</span>
        </div>
        <div class="item">
          <span class="label">诉求类型:</span>
          <span class="value">{{ detail.appealTypeDesc }}</span>
        </div>
        <div class="item">
          <span class="label">诉求内容:</span>
          <span class="value">{{ detail.appealDescription }}</span>
        </div>
        <div class="item">
          <span class="label">处理结果:</span>
          <span class="value">{{ detail.approvalStatusName }}</span>
        </div>
        <div class="item">
          <span class="label">备注:</span>
          <span class="value">{{ detail.approvalDescription }}</span>
        </div>
      </div>
      <div slot="btns">
        <el-button @click="handleClose" style="margin-right: 20px;">关 闭</el-button>
      </div>
    </Dialogs>
    <Dialogs title="处理" :is-show-dialog="isShowDialog" width="35%" @handleClick="closeDialog">
      <div slot="content">
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="结果" prop="approvalStatus">
            <el-radio-group v-model="ruleForm.approvalStatus">
              <el-radio :label="1">应答</el-radio>
              <el-radio :label="-1">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注" prop="approvalDescription">
            <el-input type="textarea" v-model="ruleForm.approvalDescription" maxlength="50" show-word-limit :autosize="{ minRows: 3, maxRows: 6}"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="btns">
        <el-button @click="closeDialog" style="margin-right: 20px;">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">保 存</el-button>
      </div>
    </Dialogs>
  </div>
</template>
<script>
import Page from '@/components/Page.vue'
import Dialogs from '@/components/page/Dialogs.vue'
import { appealList, approval } from '@/api/appealList'

export default {
  components: {
    Page,
    Dialogs
  },
  data () {
    const queryTime = []
    return {
      queryTime,
      searchBar: {
        list: [{
          type: 'input',
          prop: 'appealName',
          label: '姓名',
          placeholder: '请输入'
        }, {
          type: 'input',
          prop: 'appealPhone',
          label: '电话',
          placeholder: '请输入'
        }, {
          type: 'btn',
          text: '搜索',
          btnType: 'primary',
          callback: this.searchBarform
        }, {
          type: 'btn',
          text: '重置',
          btnType: 'primary',
          isReset: true,
          callback: this.resetList
        }]
      },
      params: {
        appealName: '',
        phone: ''
      },
      table: {
        selection: false, // 是否开启选择框
        tableInfo: [ {
          key: 'num',
          name: '序号',
          minWidth: 20
        }, {
          key: 'userId',
          name: '会员ID',
          minWidth: 40
        }, {
          key: 'appealName',
          name: '姓名',
          minWidth: 40
        }, {
          key: 'appealPhone',
          name: '电话',
          minWidth: 40
        }, {
          key: 'appealDate',
          name: '申请时间',
          minWidth: 45
        }, {
          key: 'appealTypeDesc',
          name: '诉求类型',
          minWidth: 40
        }, {
          key: 'appealDescription',
          name: '诉求内容',
          minWidth: 60
        }, {
          key: 'approvalStatusName',
          name: '状态',
          minWidth: 30
        }, {
          key: 'approvalDescription',
          name: '备注',
          minWidth: 60
        }],
        tableData: []
      },
      pagination: {
        total: 0,
        currentPage: 1,
        size: 10,
        currentChange: (page) => {
          this.handleCurrentChange(page)
        },
        sizeChange: (size) => {
          this.handleSizeChange(size)
        }
      },
      statusList: ['已拒绝', '未审批', '已处理'],
      isShowPage: false,
      detail: {},
      isShowDialog: false,
      ruleForm: {
        approvalStatus: 1,
        approvalDescription: ''
      }
    }
  },
  mounted () {
    this.getAppealList()
  },
  methods: {
    async getAppealList () {
      const {data} = await appealList({
        size: this.pagination.size,
        current: this.pagination.currentPage,
        appealName: this.params.appealName,
        appealPhone: this.params.appealPhone
      })
      this.table.tableData = data.records
      this.table.tableData.forEach((item, idx) => {
        item.num = (this.pagination.currentPage - 1) * this.pagination.size + idx + 1
        item.approvalStatusName = this.statusList[item.approvalStatus + 1]
      })
      this.pagination.total = data.total
    },
    async approval (val) {
      await approval({
        appealId: val.appealId,
        approvalStatus: val.approvalStatus,
        approvalDescription: val.approvalDescription
      })
      this.isShowDialog = false
      this.$message.success('操作成功！')
      this.getAppealList()
    },
    searchBarform (params) {
      this.ms && this.ms.close()
      this.params = {...this.params, ...params, appealPhone: params.appealPhone.trim(), appealName: params.appealName.trim()}
      const {appealName, appealPhone} = this.params
      if ((appealName && appealName.length > 20)) {
        this.ms = this.$message({
          type: 'warning',
          message: '搜索的长度不能超过20字'
        })
        return
      }
      if (appealPhone && !this.isValidPhoneNumber(appealPhone)) {
        this.ms = this.$message({
          type: 'warning',
          message: '请输入正确的手机号或座机号'
        })
        return
      }
      this.pagination.currentPage = 1
      this.getAppealList()
    },
    resetList () {
      this.pagination.currentPage = 1
      this.params = {
        appealName: '',
        phone: ''
      }
      this.queryTime = []
      this.getAppealList()
    },
    handleApproval (val) {
      this.isShowDialog = true
      this.ruleForm = {...this.ruleForm, ...val}
      this.ruleForm.approvalStatus = 1
    },
    handleSubmit () {
      this.approval(this.ruleForm)
    },
    handleSizeChange (val) {
      this.pagination.size = val
      this.$nextTick(() => {
        this.getAppealList()
      })
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      this.$nextTick(() => {
        this.getAppealList()
      })
    },
    isValidPhoneNumber (phoneNumber) {
      const reg = /^[1][3,4,5,7,8,9][0-9]{9}$/g // 校验手机
      const pattern = /^(\d{3,4}-)?[0-9]{7,8}$/g // 校验座机带-
      const tel = /^(\d{3,4})?[0-9]{7,8}$/g // 校验座机不带-
      return reg.test(phoneNumber) || pattern.test(phoneNumber) || tel.test(phoneNumber)
    },
    handleView (val) {
      this.isShowPage = true
      this.detail = val
    },
    handleClose () {
      this.isShowPage = false
    },
    closeDialog () {
      this.isShowDialog = false
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-table__body-wrapper {
  height: calc(100% - 32px);
  overflow-y: auto;
}
.alarm-log {
  width: 100%;
  height: 100%;
}
.btn {
  color: #f33458;
}
.btn.is-disabled {
  color: #C0C4CC;
}
.item {
  display: flex;
  margin-bottom: 20px;
  .label {
    width: 70px;
    text-align: right;
    margin-right: 10px;
  }
  .value {
    width: calc(100% - 70px);
    // color: #464c5e;
  }
}
</style>